import { PunchoutStore } from '../../../../components/Punchout/PunchoutStore.js';

export const PunchoutStorePath = () => <PunchoutStore />;
